import React from 'react'
import Icon from 'APP/Converse/Icon'
import { IconWrapper, Badge, BadgeText, Wrapper } from './style'
interface NotificationIconBadgeProps {
  unreadCount: number
}

export const NotificationIconBadge = React.memo(({ unreadCount }: NotificationIconBadgeProps) => {
  return (
    <Wrapper>
      <IconWrapper>
        <Icon
          src="chevron-right"
          testID="CHAT_WITH_US"
          size={24}
          color="accent"
          variant="material"
        />
        {unreadCount > 0 && (
          <Badge testID="badge">
            <BadgeText variant="caption">{unreadCount}</BadgeText>
          </Badge>
        )}
      </IconWrapper>
    </Wrapper>
  )
})

NotificationIconBadge.displayName = 'NotificationIconBadge'
